
    <input
      type="text"
      class="hidden-input"
      [(ngModel)]="search"
      [class.--show]="search && dropdownToggle"
      #hidden
      data-id="form-select-input"
    />
    <p class="input-title" *ngIf="title">{{ title }}</p>
    <div class="form-input" [class.placeholder]="!value" (click)="dropdownToggler()">
      {{ search && dropdownToggle ? '' : getName(value) || placeholder }}
      <div class="dropdown-caret"><i class="fa fa-chevron-down"></i></div>
    </div>
    <nav class="dropdown-list" [class.visible]="dropdownToggle" #dropdownList>
      <a
        href="#"
        *ngFor="let item of (options | selectSearch: search)"
        class="dropdown-link"
        [class.--active]="item.option == value"
        (click)="select(item, $event)"
        data-id="form-select-option-{{ item.option }}"
      >
        <i *ngIf="item.icon" [class]="item.icon"></i> {{ item.value }}
      </a>
      <div class="dropdown-link" *ngIf="(options | selectSearch: search).length === 0">No results found!</div>
    </nav>
    <p class="input-error" *ngIf="error">{{ error }}</p>
  


// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/shared/form/inputs/form-select.component.ts.FormSelectComponent.html